module.exports = __webpack_public_path__ + "static/media/TopProducts100.31187e14.png";